import React, { useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { CustomersFileType } from "../Common/Types/types";
import DiagramHistoryGrid from "./DiagramHistoryGrid";
import { Button } from "@progress/kendo-react-buttons";

interface NetworkDiagramProps {
  items: CustomersFileType[];
  latestItem: CustomersFileType;
}

const DIAGRAM_BASE_URL =
  "https://machinefiles.blob.core.windows.net/customerfiles";

const isSafeDiagramUrl = (url?: string | null): boolean => {
  if (!url) return false;
  return url.startsWith(DIAGRAM_BASE_URL);
};

const NetworkDiagram = (props: NetworkDiagramProps) => {
  const image = React.useRef<HTMLImageElement | null>(null);
  const [showHistory, updateShowHistory] = useState<boolean>(false);

  const url = props.latestItem?.url;
  const safeUrl = isSafeDiagramUrl(url);

  const downloadDiagram = (fileUrl: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const zoomIn = () => {
    const myImg = document.getElementById("diag") as HTMLImageElement | null;
    if (!myImg) return;
    const currWidth = myImg.clientWidth;
    if (currWidth === 2500) return;
    myImg.style.width = currWidth + 100 + "px";
  };

  const zoomOut = () => {
    const myImg = document.getElementById("diag") as HTMLImageElement | null;
    if (!myImg) return;
    const currWidth = myImg.clientWidth;
    if (currWidth === 100) return;
    myImg.style.width = currWidth - 100 + "px";
  };

  return (
    <>
      <div>
        <p>
          <b> Comment:</b> {props.latestItem.comment}
        </p>

        <>
          <Button
            onClick={() => safeUrl && downloadDiagram(url!)}
            disabled={!safeUrl}
          >
            Download Diagram
          </Button>

          <Button onClick={() => updateShowHistory(!showHistory)}>
            {showHistory ? "Hide History" : "Show History"}
          </Button>
        </>

        {showHistory && <DiagramHistoryGrid data={props.items} />}

        <div>
          <Button onClick={() => zoomIn()}>ZOOM IN</Button>
          <Button onClick={() => zoomOut()}>ZOOM OUT</Button>
        </div>

        {!safeUrl && (
          <ErrorMessage text="Diagram URL is invalid or not from trusted storage." header="Error" id="000e"/>
        )}
      </div>

      {safeUrl && <img ref={image} id="diag" src={url!} />}
    </>
  );
};

export default NetworkDiagram;
